import { call, all, put, takeEvery } from 'redux-saga/effects';
import { apiPython as api } from '../../../service/api';
import URLs from '../../../constants/urls';
import { delay } from 'redux-saga/effects';
import { normalizeTakeAssessmentPayload } from '../../../utils/apiPayload';
import { getInternalEvaluationSuccessAction, getInternalEvaluationFailureAction, getInternalEvaluationAction, 
  retakeAssessmentAction, retakeAssessmentSuccessAction, retakeAssessmentFailureAction, toggleScoreDetailsPopup, 
  getScoreDetailsAction, getScoreDetailsSuccessAction, getScoreDetailsFailureAction,
  setInternalUserAssessmentAction, setInternalUserAssessmentSuccessAction, setInternalUserAssessmentFailureAction,
 } from '../../features/internalusers/internaluserSlice';

export function* getInternalEvaluationSaga(action) {
  const payload = action.payload;

  console.log('payload ', payload);

  try {

    const response = yield api.post(URLs.TAKE_SELF_ASSESSMENT, payload);

    console.log('response', response);
   
    yield put(getInternalEvaluationSuccessAction(normalizeTakeAssessmentPayload(response.data.data)));

    yield delay(300);
    yield put(toggleScoreDetailsPopup(true));
  } catch (error) {
    console.error('error is ', error);
    yield put(getInternalEvaluationFailureAction(error?.response?.data?.message || error.message));
  }
}

export function* resetExamParametersSaga({ payload }) {
  try {
    const response = yield call(api.post, URLs.RESET_EXAM_PARAMETERS, payload);

    console.log('response', response);
    yield put(retakeAssessmentSuccessAction(response.data));

    yield call(() => setTimeout(() => window.location.reload(), 500));
    
  } catch (error) {
    console.error('ResetExamParameters error:', error);
    yield put(retakeAssessmentFailureAction(error?.response?.data || error.message));
  }
}

export function* getScoreDetailsSaga(action) {
  const { assessmentId, currentResponseId } = action.payload;
  try {
    const response = yield call(api.get, `${URLs.GET_SCORE_DETAILS}?AssessmentId=${assessmentId}&CurrentResponseId=${currentResponseId}`);

    yield put(getScoreDetailsSuccessAction(response.data));
    yield delay(300);
    yield put(toggleScoreDetailsPopup(true));
  } catch (error) {
    console.error('Score details fetch failed:', error);
    yield put(getScoreDetailsFailureAction(error?.response?.data?.message || error.message));
  }
}


function* saveInternalAssessmentResponse({ payload }) {
  try {
    const response = yield api.post(URLs.SAVE_ASSESSMENT_RESPONSE_INTERNAL, payload);
    yield put(setInternalUserAssessmentSuccessAction(response.data));
  } catch (error) {
    yield put(
      setInternalUserAssessmentFailureAction(
        error?.response?.data?.message || 'Something went wrong. Please contact administrator!'
      )
    );
  }
}



export default function* internalUserSaga() {
  yield all([
    takeEvery(getInternalEvaluationAction, getInternalEvaluationSaga),
    takeEvery(retakeAssessmentAction, resetExamParametersSaga),
    takeEvery(getScoreDetailsAction, getScoreDetailsSaga),
    takeEvery(setInternalUserAssessmentAction, saveInternalAssessmentResponse),
  ]);
}